import { Endpoint } from '../endpoint';
import { CustomerDashboardColumnStatusResponse, UpsertColumnStatusRequest } from '@business/entities/tm/CustomerDashboardColumnStatusResponse';

export function upsertColumnStatus(data: UpsertColumnStatusRequest) {
  return Endpoint.post<CustomerDashboardColumnStatusResponse>('@gc/customer-dashboard-column-statuses', { data });
}

export function deleteColumnStatus(id: string) {
  return Endpoint.delete<void>(`@gc/customer-dashboard-column-statuses/${id}`);
}
